import axios from "axios";
// import { message } from "antd";

const calculateCuote = async (request) => {
  const url = `${process.env.REACT_APP_API_URL}simulation/simulacion`;
  const result = await axios
    .post(url, request, {
      headers: {
        "Content-Type": "application/json",
      },
    })
    .catch((error) => {
      console.log({error})
      throw error   
    });
  return result.data;
};

export default calculateCuote;
